import { toFolder } from '../mappers/folder';
const isFolder = item => item['.tag'] === 'folder';
export const mapFolderList = res => ({
  ...res,
  data: (res.data.entries || []).filter(isFolder).map(toFolder)
});